import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum ERemoveCommentActionType {
  Succeed = 'postComments/removeComment/succeed',
}

export type TRemoveCommentSucceed = ITypedReduxAction<ERemoveCommentActionType.Succeed, number>;

export type TRemoveComment = TRemoveCommentSucceed;
